<template>
    <div class="d-flex align-items-center">
        
        <b-media no-body class="mr-2 d-flex align-items-center">
            <b-media-aside>
                <b-badge v-b-tooltip.hover.bottom="$t('dashboard.reminder_count')" :to="{ path: '/ReminderReport'}" variant="light-primary">
                    <feather-icon size="36" icon="BellIcon" class="mr-1" />
                    <span>{{$t('dashboard.reminder_count')}}</span>
                </b-badge>
            </b-media-aside>
            <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                    {{ reminderCount }}
                </h4>
            </b-media-body>
        </b-media>

        <b-media no-body class="mr-2 d-flex align-items-center">
            <b-media-aside>
                <b-badge v-b-tooltip.hover.bottom="$t('dashboard.dailywork')" :to="{ path: '/DailyworkReport'}" variant="light-primary">
                    <feather-icon size="36" icon="BriefcaseIcon" class="mr-1" />
                    <span>{{$t('dashboard.dailywork')}}</span>
                </b-badge>
            </b-media-aside>
            <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                    {{ activeLawDailyworkCountForUser }}
                </h4>
            </b-media-body>
        </b-media>

        <b-media no-body class="mr-2 d-flex align-items-center">
            <b-media-aside>
                <b-badge v-b-tooltip.hover.bottom="$t('dashboard.countOfLast3MonthsOfPowerOfAttorneyClients')" :to="{ path: '/LawClientPowerOfAttorneyDeadlineReport'}" variant="light-primary">
                    <feather-icon size="36" icon="ClockIcon" class="mr-1" />
                    <span>{{$t('dashboard.cutCountOfLast3MonthsOfPowerOfAttorneyClients')}}</span>
                </b-badge>
            </b-media-aside>
            <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                    {{ countOfLast3MonthsOfPowerOfAttorneyClients }}
                </h4>
            </b-media-body>
        </b-media>

        <b-media no-body class="d-flex align-items-center">
            <b-badge v-b-tooltip.hover.bottom="$t('dashboard.countOfLast1MonthsOfLawMatterCustomRegistrationsExpirationDate')" :to="{ path: '/LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReport'}" variant="light-primary">
                <feather-icon size="36" icon="AnchorIcon" class="mr-1" />
                <span>{{$t('dashboard.cutCountOfLast1MonthsOfLawMatterCustomRegistrationsExpirationDate')}}</span>
            </b-badge>
            <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0 ml-2">
                    {{ countOfLast1MonthsOfLawMatterCustomRegistrationsExpirationDate }}
                </h4>
            </b-media-body>
        </b-media>
    </div>
</template>
<script>
export default {
    data() {
        return {
            date: this.$formatFn(new Date()),
            reminderCount: 0,
            activeLawDailyworkCountForUser: 0,
            countOfLast3MonthsOfPowerOfAttorneyClients: 0,
            countOfLast1MonthsOfLawMatterCustomRegistrationsExpirationDate: 0
        }
    },
    beforeMount() {
        this.getDashboardReminders()
    },
    methods: {
        getDashboardReminders(){
            const data = {
            id: localStorage.getItem('EmployeeId')
        }
        const controller = {
            name: 'LawDashboard'
        }
        const payload = {
            data: data,
            controller: controller
        }
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if (response.data.resultStatus == true) {
                this.reminderCount = response.data.lawDashboard.reminderCount
                this.activeLawDailyworkCountForUser = response.data.lawDashboard.activeLawDailyworkCountForUser,
                this.countOfLast3MonthsOfPowerOfAttorneyClients = response.data.lawDashboard.countOfLast3MonthsOfPowerOfAttorneyClients
                this.countOfLast1MonthsOfLawMatterCustomRegistrationsExpirationDate = response.data.lawDashboard.countOfLast1MonthsOfLawMatterCustomRegistrationsExpirationDate
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        })
        }
    }
}
</script>
